import styled from "styled-components";
import {SpinnerLogoDefaultBox} from "./spinner-logo.default.box";

export const SpinnerLogoCasino777Box = styled(SpinnerLogoDefaultBox)`
  top: 0;
  left: 0;
  width: 250px;
  height: 215px;
  animation: LoadingAnimation 1s steps(3) infinite;
  background-position: -1103px -452px;

  @keyframes LoadingAnimation {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(${({isRTL}) => isRTL ? '-72%' : '72%'});
    }
  }
`;
